import { render, staticRenderFns } from "./owned-affiliates-submissions.view.vue?vue&type=template&id=53966a3d&scoped=true&"
import script from "./owned-affiliates-submissions.view.vue?vue&type=script&lang=ts&"
export * from "./owned-affiliates-submissions.view.vue?vue&type=script&lang=ts&"
import style0 from "./owned-affiliates-submissions.view.vue?vue&type=style&index=0&id=53966a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53966a3d",
  null
  
)

export default component.exports